import axios from '../api';

class DeliveryService {
  // Get delivery status
  async getStatus() {
    const response = await axios.get('/api/delivery/my-status');
    return response.data;
  }

  // Update delivery status
  async updateStatus(status: string) {
    const response = await axios.put('/api/delivery/my-status', { status });
    return response.data;
  }

  // Get the logged-in delivery person's own deliveries. The backend scopes the
  // result to DeliveryPerson.findOne({ user: req.user._id }), so a driver only
  // ever receives their own records.
  async getMyDeliveries(params?: { status?: string; page?: number; limit?: number }) {
    const response = await axios.get('/api/delivery/my-deliveries', { params });
    return response.data;
  }

  // Get incoming delivery requests for the logged-in delivery person: unassigned
  // "pending" jobs plus jobs specifically assigned to them.
  async getPending() {
    const response = await axios.get('/api/delivery/pending');
    return response.data;
  }

  // Accept a delivery request (claims it for the logged-in delivery person).
  async acceptDelivery(deliveryId: string) {
    const response = await axios.put(`/api/delivery/${deliveryId}/accept`);
    return response.data;
  }

  // Reject a delivery assigned to the logged-in delivery person.
  async rejectDelivery(deliveryId: string, reason?: string) {
    const response = await axios.put(`/api/delivery/${deliveryId}/reject`, { reason });
    return response.data;
  }

  // Get the logged-in delivery person's earnings/stats summary (today / week / total).
  async getEarningsSummary() {
    const response = await axios.get('/api/delivery/earnings/summary');
    return response.data;
  }
}

const deliveryService = new DeliveryService();
export default deliveryService;
